import React, { useState } from "react";
import "../styles/ProductSelector.css";

const ProductSelector = ({
  selectedProducts,
  onSelectProduct,
  onRemoveProduct,
}) => {
  const [showSelector, setShowSelector] = useState(false);
  const [showRecipientSelector, setShowRecipientSelector] = useState(false);
  // Lista de destinatarios disponibles
  const recipients = [
    {
      id: 1,
      name: "Marlenis Rodríguez",
      role: "Propietaria",
      phone: "5354900157",
      department: "Atención al Cliente",
      avatar: "👨‍💼",
    },
    {
      id: 2,
      name: "Liudmila",
      role: "Servicio al Cliente",
      phone: "573001234568",
      department: "Reservas",
      avatar: "👩‍💼",
    },
    {
      id: 3,
      name: "Yanet Ruiz",
      role: "Cajera-Vendedora",
      phone: "5356265816",
      department: "Ventas",
      avatar: "📦",
    },
  ];

  const getTotalPrice = () => {
    return selectedProducts.reduce(
      (total, item) => total + item.precio * item.quantity,
      0,
    );
  };
  
  const getTotalPrice_usd = () => {
    return selectedProducts.reduce(
      (total, item) => total + item.pv_usd * item.quantity,
      0,
    );
  };

  const getTotalItems = () => {
    return selectedProducts.reduce((total, item) => total + item.quantity, 0);
  };

  const generateWhatsAppMessage = (recipient) => {
    let message = `🛒 *Pedido para ${recipient.name} (${recipient.department})*%0A`;
    message += `📅 ${new Date().toLocaleDateString()} - ${new Date().toLocaleTimeString()}%0A`;
    message += `━━━━━━━━━━━━━━━━━━━━%0A%0A`;

    message += `*📋 DETALLE DEL PEDIDO:*%0A`;
    message += `━━━━━━━━━━━━━━━━━━━━%0A%0A`;

    selectedProducts.forEach((item, index) => {
      message += `${index + 1}. *${item.nombre}*%0A`;
      message += `   📦 Cantidad: ${item.quantity} ${item.unidad}%0A`;
      message += `   💰 Precio unitario: $${item.precio.toFixed(2)}%0A`;
      message += `   💵 Subtotal: $${(item.precio * item.quantity).toFixed(2)}%0A`;
      message += `   ─────────────────%0A`;
    });

    message += `%0A*💰 TOTAL DEL PEDIDO: $${getTotalPrice().toFixed(2)}*%0A`;
    message += `*📦 TOTAL DE PRODUCTOS: ${getTotalItems()} unidades*%0A`;
    message += `━━━━━━━━━━━━━━━━━━━━%0A%0A`;

    message += `*👤 DATOS DEL CLIENTE:*%0A`;
    message += `Nombre: _______________%0A`;
    message += `Teléfono: _______________%0A`;
    message += `Dirección: _______________%0A`;
    message += `Correo: _______________%0A%0A`;

    message += `*📝 COMENTARIOS ADICIONALES:*%0A`;

    message += `🙏 *¡Gracias por tu compra en Tiendas EMA!*%0A`;
    message += `✨ Un asesor te contactará pronto.`;

    return message;
  };

  const handleSendToWhatsApp = (recipient) => {
    const message = generateWhatsAppMessage(recipient);
    window.open(`https://wa.me/${recipient.phone}?text=${message}`, "_blank");
    setShowRecipientSelector(false);
    setShowSelector(false);
  };

  const handleProceedToRecipient = () => {
    if (selectedProducts.length === 0) {
      alert("No hay productos seleccionados");
      return;
    }
    setShowRecipientSelector(true);
  };

  return (
    <div className="product-selector">
      {/* Botón flotante del carrito */}
      {selectedProducts.length > 0 && (
        <button className="cart-float" onClick={() => setShowSelector(true)}>
          🛒 {selectedProducts.length}
          <span className="cart-badge">{getTotalItems()}</span>
        </button>
      )}

      {/* Modal del carrito */}
      {showSelector && (
        <div className="cart-modal" onClick={() => setShowSelector(false)}>
          <div
            className="cart-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="cart-header">
              <h3>🛍️ Solicitud de Compra</h3>
              <button
                className="close-btn"
                onClick={() => setShowSelector(false)}
              >
                ✕
              </button>
            </div>

            <div className="cart-items">
              {selectedProducts.length === 0 ? (
                <div className="empty-cart">
                  <p>🛒 No hay productos seleccionados</p>
                  <p className="empty-cart-hint">
                    Explora nuestro catálogo y selecciona productos
                  </p>
                </div>
              ) : (
                <>
                  {selectedProducts.map((item) => (
                    <div key={item.codigo} className="cart-item">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/${item.codigo}.webp`}
                        alt={item.nombre}
                        onError={(e) =>
                          (e.target.src = `${process.env.PUBLIC_URL}/images/placeholder.webp`)
                        }
                      />
                      <div className="cart-item-details">
                        <h4>{item.nombre}</h4>
                        <p className="cart-item-code">Código: {item.codigo}</p>
                        <p className="cart-item-price">
                          Precio: ${item.precio.toFixed(2)}
                        </p>
                        <p className="cart-item-price">
                          Precio_USD: {item.pv_usd.toFixed(2)}
                        </p>
                        <div className="quantity-control">
                          <button
                            onClick={() => onRemoveProduct(item.codigo, 1)}
                          >
                            −
                          </button>
                          <span>{item.quantity}</span>
                          <button onClick={() => onSelectProduct(item)}>
                            +
                          </button>
                        </div>
                      </div>
                      <button
                        className="remove-item"
                        onClick={() =>
                          onRemoveProduct(item.codigo, item.quantity)
                        }
                        title="Eliminar producto"
                      >
                        🗑️
                      </button>
                    </div>
                  ))}
                </>
              )}
            </div>

            <div className="cart-footer">
              <div className="cart-summary">
                <div className="cart-total-items">
                  📦 Total productos: <strong>{getTotalItems()}</strong>
                </div>
                <div className="cart-total">
                  💰 Total a pagar:{" "}
                  <strong>${getTotalPrice().toFixed(2)}</strong>
                  <strong>  ({getTotalPrice_usd().toFixed(2)} USD)</strong>
                </div>
              </div>

              <div className="cart-actions">
                <button
                  className="clear-cart"
                  onClick={() => {
                    selectedProducts.forEach((item) =>
                      onRemoveProduct(item.codigo, item.quantity),
                    );
                    setShowSelector(false);
                  }}
                >
                  🗑️ Vaciar carrito
                </button>
                <button
                  className="send-whatsapp"
                  onClick={handleProceedToRecipient}
                  disabled={selectedProducts.length === 0}
                >
                  📱 Continuar a WhatsApp →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de selección de destinatario */}
      {showRecipientSelector && (
        <div
          className="recipient-modal"
          onClick={() => setShowRecipientSelector(false)}
        >
          <div
            className="recipient-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="recipient-header">
              <h2>📨 ¿A quién deseas enviar tu pedido?</h2>
              <button
                className="close-btn"
                onClick={() => setShowRecipientSelector(false)}
              >
                ✕
              </button>
            </div>

            <div className="recipient-list">
              {recipients.map((recipient) => (
                <button
                  key={recipient.id}
                  className="recipient-card"
                  onClick={() => handleSendToWhatsApp(recipient)}
                >
                  <div className="recipient-avatar">{recipient.avatar}</div>
                  <div className="recipient-info">
                    <h3>{recipient.name}</h3>
                    <p className="recipient-role">{recipient.role}</p>
                    <p className="recipient-department">
                      📂 {recipient.department}
                    </p>
                  </div>
                  <div className="recipient-whatsapp-icon">💬</div>
                </button>
              ))}
            </div>

            <div className="recipient-footer">
              <p className="recipient-note">
                💡 Todos nuestros asesores están disponibles en horario laboral
              </p>
              <p className="recipient-note">(Lun-Sáb 8am-3pm || Dom 8am-12M)</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductSelector;
